var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sign-in-sign-up-layout"},[_c('div',{staticClass:"left-side"},[_c('SignInSignUpContent',[_vm._t("default")],2),_c('div',{staticClass:"copywrite"},[_vm._v("© "+_vm._s(_vm.year)+" EasyAgency. All rights reserved.")])],1),_c('div',{staticClass:"right-side"})])
}
var staticRenderFns = []

export { render, staticRenderFns }